<template>
<!--    <Message severity="warn" :closable="false">-->
<!--        <div class="ml-2">Это демонстрационный бот, делающий бэктест по старым данным. Бот предназначен для тестирования нового алгоритма автоматического подбора параметров.</div>-->
<!--        <div class="ml-2 mt-2" v-if="currentDate">Текущая дата: {{currentDate}}</div>-->
<!--    </Message>-->
</template>
<script>
import Message from 'primevue/message';
export default {
    props:{
        currentDate: String
    },
    components:{
        Message
    }
}
</script>
